import DeliveryIssueModal from 'components/GlobalModals/DeliveryIssueModal/DeliveryIssueModal';
import { withDeliveryIssueModalProps } from 'viewModel/globalModals/deliveryIssueModal/withDeliveryIssueModalProps';

export default withDeliveryIssueModalProps(DeliveryIssueModal);
